import type { GitWorktreeBaseFallbackReason } from "@taskin-code/contracts";

/**
 * Why a thread's branch had to start from the local copy of its base.
 *
 * Each one points at a different fix — connect the repository, check the
 * network, pick another base — so they are not collapsed into one generic
 * "could not fetch".
 */
export function describeWorktreeBaseFallback(
  reason: GitWorktreeBaseFallbackReason | undefined,
): string {
  switch (reason) {
    case "no-remote":
      return "El repositorio no tiene remoto configurado.";
    case "fetch-failed":
      return "No se pudo hacer fetch del remoto (sin red, sin credenciales o token rechazado).";
    case "remote-branch-missing":
      return "Esa rama no existe en el remoto.";
    case "configured-local":
      return "El proyecto está configurado para partir de la rama local.";
    default:
      return "No se pudo usar la copia remota de la rama base.";
  }
}
